"use client";

import { useMessages } from "@/lib/i18n/useMessages";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { ArrowOutward } from "@mui/icons-material";
import { Button } from "@mui/material";
import { motion } from "motion/react";
import { SLLink } from "../i18n/SLLink";
import { SLButtonGroupChatBuchen } from "../buttons/SLButtonGroupChatBuchen";
import { SLHtmlFromLangFile } from "../sections/home/SLHtmlFromLangFile";

export const SLCard = ({
  title,
  description,
  learnMoreHref,
  specialLinks,
  backgroundColor,
  textColor,
  hasOpenChatButton,
  hasBookAppointmentButton,
}: {
  title: string;
  description: string;
  learnMoreHref?: string;
  specialLinks?: {
    title: string;
    href: string;
  }[];
  backgroundColor?: string;
  textColor?: string;
  hasOpenChatButton?: boolean;
  hasBookAppointmentButton?: boolean;
}) => {
  const learnMoreLabel = useMessages().common.learnMore;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      style={{
        height: "100%",
      }}
    >
      <Card
        sx={{
          height: "100%",
          backgroundColor: backgroundColor || theme.palette.background.paper,
          boxShadow: "none",
        }}
      >
        <Stack direction="column" justifyContent="space-between" height="100%">
          <Stack>
            <CardHeader
              title={<SLHtmlFromLangFile htmlString={title} />}
              slotProps={{
                title: {
                  color: textColor || theme.palette.text.primary,
                },
              }}
            />
            <CardContent sx={{ height: "100%" }}>
              <Typography color={textColor || theme.palette.text.primary}>
                <SLHtmlFromLangFile htmlString={description} />
              </Typography>
            </CardContent>
          </Stack>

          <CardActions
            sx={{
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "flex-end",
            }}
          >
            {learnMoreHref && (
              <Button
                component={SLLink}
                href={learnMoreHref}
                color="success"
                startIcon={<ArrowOutward />}
              >
                {learnMoreLabel}
              </Button>
            )}

            {specialLinks &&
              specialLinks.map((link) => (
                <Button
                  key={link.href}
                  component={SLLink}
                  href={link.href}
                  color="success"
                  startIcon={<ArrowOutward />}
                >
                  <SLHtmlFromLangFile htmlString={link.title} />
                </Button>
              ))}
            <SLButtonGroupChatBuchen
              hasOpenChatButton={hasOpenChatButton}
              hasBookAppointmentButton={hasBookAppointmentButton}
            />
          </CardActions>
        </Stack>
      </Card>
    </motion.div>
  );
};
